<template>
  <BaseModal
    :max-width="540"
    :pivot-y="0.1"
    :before-open="beforeOpen"
    :on-close="onClose"
    name="terms-modal"
    :click-to-close="false"
  >
    <div class="terms-modal-block">
      <new-user
        v-if="newUser && currentStep === 1"
        :change-step="changeStep"
        :go-to-link="goToLink"
        :accept="onAcceptTerms"
      />
      <old-user
        v-if="!newUser && currentStep === 1"
        :change-step="changeStep"
        :go-to-link="goToLink"
        :accept="onAcceptTerms"
      />
      <cancel-registration
        v-if="currentStep === 2"
        :change-step="changeStep"
        :cancel-registration="onCancelRegistration"
      />
      <registration-cancelled v-if="currentStep === 3" :send-feedback="() => {}" />
    </div>
  </BaseModal>
</template>

<script>
import { changeUserInfo, deactivateAccount, userLogout } from '@bookis/store'
import BaseModal from '../Base'
import NewUser from './NewUser'
import OldUser from './OldUser'
import CancelRegistration from './CancelRegistration'
import RegistrationCancelled from './RegistrationCancelled'
import { logout } from '@/utils/auth'

export default {
  name: 'TermsModal',
  components: {
    RegistrationCancelled,
    CancelRegistration,
    OldUser,
    NewUser,
    BaseModal
  },
  data() {
    return {
      newUser: null,
      currentStep: 1
    }
  },
  map: state => ({
    userId: state.user.userInfo && state.user.userInfo.id
  }),
  actions: {
    userLogout
  },
  methods: {
    beforeOpen(event) {
      this.newUser = event.params.newUser
    },
    changeStep(number) {
      this.currentStep = number
    },
    onClose() {
      this.newUser = null
      this.currentStep = 1
    },
    closeModal() {
      this.$modal.hide('terms-modal')
    },
    goToLink(link) {
      this.closeModal()
      this.$router.push(link).catch(() => {})
    },
    checkIntercomStatus(value) {
      if (window.Intercom) {
        window.Intercom('update', { unsubscribed_from_emails: value })
      } else {
        setTimeout(() => {
          this.checkIntercomStatus(value)
        }, 1000)
      }
    },
    onAcceptTerms({ subscribeToMarketingEmail }) {
      this._store
        .dispatchAsync(
          changeUserInfo({
            fields: {
              acceptedTerms: true,
              subscribeToMarketingEmailEnabled: subscribeToMarketingEmail
            }
          })
        )
        .then(() => {
          if (window.CookieInformation) {
            window.CookieInformation.submitAllCategories()
          }
          this.checkIntercomStatus(!subscribeToMarketingEmail)
          this.closeModal()
        })
    },
    onCancelRegistration() {
      this.changeStep(3)
      this._store
        .dispatchAsync(
          deactivateAccount({
            userId: this.$state.userId
          })
        )
        .then(() => {
          logout(this.$router, this.$cookies)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/local-variables';
.terms-modal-block {
  max-width: 396px;
  margin: 10px auto 24px;
  & ::v-deep {
    color: $color-neutral-900;
    h1 {
      font-size: 37px;
      font-weight: 600;
      line-height: 42px;
      text-align: center;
      @media (max-width: 500px) {
        font-size: 27px;
      }
    }
    a {
      font-weight: 600;
      color: $color-primary;
      cursor: pointer;
    }
    b {
      display: block;
    }
    p {
      @media (max-width: 500px) {
        font-size: $font-size-sm;
      }
    }
    .buttons {
      display: flex;
      margin-top: 40px;
      justify-content: center;
      @media (max-width: 500px) {
        margin-top: 20px;
      }
      .button {
        margin: 0 8px;
        font-weight: 600;
        flex: 1;
        min-width: initial;
      }
    }
  }
}
</style>
